var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"asset mirrored",style:(_vm.cssVars),attrs:{"loading":_vm.lazy,"src":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }